module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video4.2793c039.mp4";